export default "__VITE_PUBLIC_ASSET__ed262e1e__"